<template>
    <div class="payment-page">
        <!-- 头部组件 -->
        <Header />

        <div class="content-wrapper">
            <!-- 导航路径 -->
            <div class="breadcrumb" v-if="is_from == 1">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '2',
                        },
                    }">供应大厅</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-2)">商品详情</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-1)">立即购买</el-breadcrumb-item>
                    <el-breadcrumb-item>提交订单</el-breadcrumb-item>
                </el-breadcrumb>
            </div>


            <div class="breadcrumb" v-if="is_from == 2">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-1)">发布推广</el-breadcrumb-item>
                    <el-breadcrumb-item>提交订单</el-breadcrumb-item>

                </el-breadcrumb>
            </div>

            <div class="breadcrumb" v-if="is_from == 3">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-1)">购买会员</el-breadcrumb-item>
                    <el-breadcrumb-item>提交订单</el-breadcrumb-item>

                </el-breadcrumb>
            </div>

            <div class="breadcrumb" v-if="is_from == 5">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-1)">结算单</el-breadcrumb-item>
                    <el-breadcrumb-item>提交订单</el-breadcrumb-item>

                </el-breadcrumb>
            </div>



            <!-- 订单信息区域 -->
            <div class="order-info-section">
                <div class="order-info-content">
                    <div class="order-success">创建订单成功，请尽快付款！</div>
                    <div class="order-details">
                        <span>订单编号：{{ $route.query.order_sn }}</span>
                        <span class="order-timer" v-if="is_from == 1">请在{{ remainingMinutes }}分钟内支付，否则订单自动取消</span>
                        <span class="order-timer" v-if="is_from == 5">结算单付款，请尽快完成支付</span>
                    </div>
                    <div class="order-amount">
                        <span class="label">应付金额：</span>
                        <span class="amount">¥{{ money }}</span>
                    </div>
                </div>
            </div>

            <!-- 支付方式选择 -->
            <div class="payment-method-section">
                <div class="payment-method-list">
                    <div class="payment-method-item" :class="{ 'active': selectedPayment == 'wechat' }"
                        @click="selectPayment('wechat')">
                        <img src="../../assets/images/56.png" alt="微信支付" class="payment-icon">
                        <span class="payment-name">微信支付</span>
                    </div>
                    <div class="payment-method-item" :class="{ 'active': selectedPayment == 'alipay' }"
                        @click="selectPayment('alipay')">
                        <img src="../../assets/images/57.png" alt="支付宝支付" class="payment-icon">
                        <span class="payment-name">支付宝支付</span>
                    </div>
                    <div class="payment-method-item" :class="{ 'active': selectedPayment == 'balance' }"
                        @click="selectPayment('balance')">
                        <img src="../../assets/images/68.png" alt="余额支付" class="payment-icon">
                        <span class="payment-name">余额支付</span>
                        <span class="balance-amount">¥{{ balance }}</span>
                    </div>
                </div>
            </div>
            <!-- 订单商品信息 -->
            <div class="order-goods-section" v-if="is_from != 5">
                <div class="section-title">订单商品信息</div>
                <div class="goods-info-card">
                    <div class="goods-image">
                        <img :src="orderGoods.thumb" :alt="orderGoods.goods_name">
                    </div>
                    <div class="goods-details">
                        <div class="goods-name">{{ orderGoods.goods_name }}</div>
                        <div class="goods-sku" v-if="orderGoods.sku_name">规格：{{ orderGoods.sku_name }}</div>
                        <div class="goods-price-info">
                            <span class="unit-price">¥{{ orderGoods.shop_price }}</span>
                            <span class="goods-unit" v-if="orderGoods.unit">/{{ orderGoods.unit }}</span>
                            <span class="multiply">×</span>
                            <span class="goods-num">{{ orderGoods.num }}</span>
                        </div>
                        <div class="goods-total">
                            <span class="total-label">小计：</span>
                            <span class="total-price">¥{{ orderGoods.total_amount }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 结算单信息 -->
            <div class="order-goods-section" v-else>
                <div class="section-title">结算单信息</div>
                <div class="goods-details">
                    <div class="goods-name">结算单号：{{ $route.query.order_sn }}</div>
                    <div class="goods-sku">应付金额：¥{{ money }}</div>
                </div>
            </div>

            <!-- 支付二维码区域 -->
            <div class="payment-qrcode-section" v-if="selectedPayment === 'wechat'">
                <div class="qrcode-title">微信支付</div>
                <div class="qrcode-instruction">打开微信扫一扫，扫描下方二维码完成支付</div>
                <!-- <iframe :src="wxQRurl" width="100%" height="600px" frameborder="0" scrolling="no" /> -->

                <div class="qrcode-container">
                    <div class="qrcode">

                        <img :src="wxQRurl" alt="微信支付二维码" class="qrcode-image">

                    </div>
                </div>
            </div>

            <div class="payment-qrcode-section" v-if="selectedPayment === 'alipay'">
                <div class="qrcode-title">支付宝支付</div>
                <div class="qrcode-instruction">打开支付宝扫一扫，扫描下方二维码完成支付</div>
                <iframe :src="aliQRurl" width="100%" height="600px" frameborder="0" scrolling="no" />
            </div>
            <div class="payment-qrcode-section" v-if="selectedPayment === 'balance'">
                <div class="qrcode-title">余额支付</div>
                <div class="balance-amount">当前账户剩余额度</div>
                <div class="balance-amount-available">￥{{ balance }}</div>
                <div class="balance-amount-warning" v-if="balanceStatus">提示：您的余额不足，请更换支付方式</div>
                <el-button class="balance-pay-button" type="primary" @click="handleBalancePay"
                    v-if="!balanceStatus">提交</el-button>
            </div>
        </div>

        <!-- 底部组件 -->
        <Footer />

        <!-- 6位数密码输入弹窗 -->
        <el-dialog title="请输入6位数字密码" :visible.sync="passwordDialogVisible" width="600px" :close-on-click-modal="false"
            :close-on-press-escape="false">
            <div class="password-dialog-content">
                <!-- <div class="payment-info">
                    <span class="label">支付金额：</span>
                    <span class="amount">¥{{ money }}</span>
                </div> -->
                <div class="password-input-wrapper">
                    <div class="password-input-container">
                        <input type="number" class="password-input" v-model="paymentPassword" maxlength="6"
                            placeholder="请输入6位支付密码" ref="passwordInput">
                        <div class="password-dots-container">
                            <div v-for="(dot, index) in 6" :key="index" class="password-dot"
                                :class="{ filled: paymentPassword.length > index }"></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="password-actions">
                    <el-button type="text" @click="forgotPassword">忘记密码？</el-button>
                </div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passwordDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmPassword"
                    :disabled="paymentPassword.length !== 6">确认支付</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入头部和底部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'

export default {
    name: 'PaymentPage',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            aliQRurl: "",//支付宝二维码
            wxQRurl: "",//微信二维码
            // 订单信息
            orderId: '',
            orderAmount: 0,
            // 支付倒计时
            countdown: 0, // 30分钟
            countdownTimer: null, // 新增：倒计时定时器
            pollTimer: null, // 新增：轮询定时器
            isPolling: false, // 新增：是否正在轮询
            // 支付方式
            selectedPayment: 'wechat',
            // 余额
            balance: 0,
            balanceStatus: false,

            // 密码弹窗相关
            passwordDialogVisible: false,
            paymentPassword: '',
            is_from: this.$route.query.is_from || 1, // 1是购买商品，2是推广,3是会员购买

            order_sn: '',
            money: 0, // 新增：支付金额
            order_type: 3, // 新增：订单类型
            order_config_id: 14, // 新增：订单配置ID

            // 订单商品信息
            orderGoods: {
                goods_name: '',
                thumb: '',
                sku_name: '',
                shop_price: '',
                num: 0,
                unit: '',
                total_amount: 0
            },
        }
    },
    created() {
        // 从路由参数获取订单信息
        this.countdown = this.$route.params.time || ''
        this.money = this.$route.params.money || 0
        this.order_type = this.$route.params.order_type || 3
        this.order_config_id = this.$route.params.order_config_id || 14

        this.getUserBalance()
    },
    mounted() {
        console.log("is_from", this.is_from);
        console.log("countdown", this.countdown);
        this.order_sn = this.$route.query.order_sn;
        // 根据默认支付方式获取支付信息
        this.getPaymentInfo(this.selectedPayment);
        if (this.is_from != 5) {
            this.getPayGoods();
        }
        // 启动倒计时（结算单无过期时间，不启动）
        if (this.is_from != 5) {
            this.startCountdown();
        }
        // 启动支付状态轮询
        this.startPolling();
    },
    computed: {
        // 剩余分钟数
        remainingMinutes() {
            // 向上取整，确保显示的分钟数足够支付
            return Math.ceil(this.countdown / 60)
        },
        // 格式化倒计时时间（mm:ss）
        formattedCountdown() {
            const minutes = Math.floor(this.countdown / 60)
            const seconds = this.countdown % 60
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        }
    },
    methods: {
        // 获取商品信息
        getPayGoods() {
            this.$api.getPayGoods({
                order_sn: this.order_sn
            }).then(res => {
                console.log('获取商品信息成功：', res);
                const sku = res.sku && res.sku.length > 0 ? res.sku[0] : {};
                this.orderGoods = {
                    goods_name: res.goods_name || '',
                    thumb: res.thumb || (sku.spec_img || ''),
                    sku_name: sku.key_name || '',
                    shop_price: sku.shop_price || '0.00',
                    num: sku.num || 0,
                    unit: sku.unit || '',
                    total_amount: res.total_amount || 0
                };
            }).catch(err => {
                console.log('获取商品信息失败：', err);
            });
        },
        // 启动倒计时
        startCountdown() {
            // 无有效倒计时时间（如结算单）则不启动
            if (!this.countdown || this.countdown <= 0) return;
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
            }
            this.countdownTimer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.handleOrderExpired();
                }
            }, 1000);
        },
        // 启动支付状态轮询
        startPolling() {
            if (this.isPolling) return;
            this.isPolling = true;
            this.pollTimer = setInterval(() => {
                this.checkPayStatus();
            }, 3000);
            // 立即查询一次
            this.checkPayStatus();
        },
        // 查询支付状态
        checkPayStatus() {
            this.$api.getPayResult({
                order_sn: this.order_sn,
                order_config_id: this.order_config_id
            }).then(res => {
                 this.handlePaymentSuccess();
            }).catch(err => {
                console.log('查询支付状态失败：', err);
            });
        },
        // 支付成功处理
        handlePaymentSuccess() {
            this.clearTimers();
            this.$message.success('支付成功！');
            this.$router.replace({
                path: '/payment-success',
                query: {
                    order_sn: this.order_sn,
                    is_from: this.is_from
                }
            });
        },
        // 清除所有定时器
        clearTimers() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
            this.isPolling = false;
        },
        // 根据支付方式获取支付信息
        getPaymentInfo(method) {
            switch (method) {
                case 'wechat':
                    // 微信支付：调用获取支付信息接口（与支付宝使用同一个接口）
                    this.getWxPay();
                    break;
                case 'alipay':
                    // 支付宝支付：调用获取支付信息接口
                    this.getAliPay();
                    break;
                case 'balance':
                    // 余额支付不需要获取支付信息
                    break;
                default:
                    break;
            }
        },
        // 微信支付链接
        getWxPay() {
            this.$api.getWxPayInfo({
                order_sn: this.order_sn,
                order_config_id: this.order_config_id
            }).then(res => {
                this.wxQRurl = res.qrcode;
            })
        },
        // 阿里支付链接
        getAliPay() {
            this.$api.getPayInfo({
                order_sn: this.order_sn,
                order_config_id: this.order_config_id
            }).then(res => {
                this.aliQRurl = res.url;
            })
        },
        // 订单过期处理
        handleOrderExpired() {
            this.clearTimers();
            this.$message.error('订单已过期，请重新下单')
            // 跳转到首页或商品详情页
            // this.$router.push('/')
        },

        // 选择支付方式
        selectPayment(method) {
            // 如果选择的是当前已选的支付方式，不重复处理
            if (this.selectedPayment === method) return;

            // 清除所有定时器
            this.clearTimers();
            // 重置支付宝二维码（切换时销毁之前的支付信息）
            this.aliQRurl = "";
            // 重置微信二维码（切换时销毁之前的支付信息）
            this.wxQRurl = "";

            // 更新选中的支付方式
            this.selectedPayment = method;

            // 根据新的支付方式获取支付信息
            this.getPaymentInfo(method);

            // 重新启动倒计时和轮询
            this.startCountdown();
            this.startPolling();
        },

        // 用户信息取余额
        getUserBalance() {
            // 模拟从后端获取用户余额
            this.$api.userInfo().then(res => {
                this.balance = res.total_money
                if (this.balance < this.money) {
                    this.balanceStatus = true
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },

        // 余额支付提交
        handleBalancePay() {
            if (this.balanceStatus) {
                this.$message.error('余额不足，请更换支付方式')
                return
            }
            // 打开密码输入弹窗
            this.passwordDialogVisible = true
            this.$nextTick(() => {
                this.$refs.passwordInput.focus()
            })
        },

        // 确认支付密码
        confirmPassword() {
            if (this.paymentPassword.length !== 6) {
                this.$message.warning('请输入6位支付密码')
                return
            }
            // 调用余额支付接口，传递支付密码
            this.$api.balancePay({
                order_sn: this.$route.query.order_sn || '',
                order_config_id: this.order_config_id || '',
                pay_password: this.paymentPassword
            }).then(res => {
                this.$message.success('余额支付成功')
                this.passwordDialogVisible = false
                this.paymentPassword = ''
                // 跳转到支付成功页
                this.$router.replace({
                    path: '/payment-success',
                    query: {
                        order_sn: this.$route.query.order_sn,
                        is_from: this.is_from
                    }
                })
            }).catch(err => {
                this.$message.error(err || '支付失败，请稍后重试')
                this.paymentPassword = ''
            })
        },


    },
    beforeDestroy() {
        // 组件销毁前清除定时器，防止内存泄漏
        this.clearTimers();
    }
}
</script>

<style scoped>
.payment-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    padding: 24px 0 20px 0;
}

/* 订单信息区域样式 */
.order-info-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.order-info-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.order-success {
    color: #67c23a;
    font-weight: 500;
    margin-bottom: 8px;
}

.order-details {
    display: flex;
    gap: 20px;
    color: #606266;
    font-size: 14px;
}

.order-timer {
    color: #f56c6c;
}

.order-amount {
    display: flex;
    align-items: center;
}

.order-amount .label {
    color: #606266;
    margin-right: 8px;
}

.order-amount .amount {
    color: #f56c6c;
    font-size: 24px;
    font-weight: bold;
}

/* 订单商品信息样式 */
.order-goods-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    text-align: left;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
    text-align: left;
}

.goods-info-card {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    width: 100%;
    text-align: left;
}

.goods-image {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #e4e7ed;
    flex-shrink: 0;
    flex-grow: 0;
}

.goods-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.goods-details {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: left;
}

.goods-name {
    font-size: 15px;
    font-weight: 500;
    color: #303133;
    line-height: 1.4;
    text-align: left;
}

.goods-sku {
    font-size: 13px;
    color: #909399;
    text-align: left;
}

.goods-price-info {
    display: flex;
    align-items: baseline;
    gap: 4px;
    font-size: 14px;
    text-align: left;
}

.unit-price {
    color: #f56c6c;
    font-weight: 500;
}

.goods-unit {
    color: #909399;
    font-size: 13px;
}

.multiply {
    color: #909399;
    margin: 0 8px;
}

.goods-num {
    color: #303133;
    font-weight: 500;
}

.goods-total {
    display: flex;
    align-items: center;
    margin-top: 4px;
    text-align: left;
}

.total-label {
    font-size: 14px;
    color: #606266;
}

.total-price {
    font-size: 18px;
    font-weight: bold;
    color: #f56c6c;
}

/* 支付方式选择样式 */
.payment-method-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.payment-method-list {
    display: flex;
    gap: 40px;
}

.payment-method-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    border: 2px solid #e4e7ed;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
}

.payment-method-item.active {
    border-color: #409eff;
    background-color: #ecf5ff;
}

.payment-method-item:hover {
    border-color: #409eff;
}

.payment-icon {
    width: 40px;
    height: 40px;
}

.payment-name {
    font-size: 16px;
    color: #303133;
}

.balance-amount {
    margin-left: 10px;
    color: #e6a23c;
    font-weight: 500;
}

/* 支付二维码区域样式 */
.payment-qrcode-section {
    background-color: #fff;
    padding: 40px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    text-align: center;
}

.qrcode-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #303133;
}

.qrcode-instruction {
    margin-bottom: 40px;
    color: #606266;
    font-size: 14px;
}

.qrcode-container {
    display: flex;
    justify-content: center;
    position: relative;
}

.qrcode {
    width: 200px;
    height: 200px;
    padding: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
}

.qrcode img {
    width: 100%;
    height: 100%;
}

.qrcode-tooltip {
    position: absolute;
    top: 50%;
    right: 20%;
    transform: translateY(-50%);
    background-color: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.tooltip-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    color: #606266;
    font-size: 14px;
}

.tooltip-item i {
    color: #409eff;
}

.balance-amount {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
}

.balance-amount-available {
    font-weight: 800;
    font-size: 28px;
    color: #F02325;
    margin: 16px 0 12px 0;
}

.balance-amount-warning {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
}

.balance-pay-button {
    width: 240px;
    height: 48px;
    background: #286CED;
    border-radius: 2px 2px 2px 2px;
    margin-top: 32px;
}

/* 密码弹窗样式 */
.password-dialog-content {
    padding: 20px 0;
}

.payment-info {
    text-align: center;
    margin-bottom: 30px;
}

.payment-info .label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
}

.payment-info .amount {
    font-size: 24px;
    color: #f56c6c;
    font-weight: bold;
}

.password-input-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.password-input-container {
    position: relative;
    width: 280px;
}

.password-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    opacity: 0;
    z-index: 10;
    font-size: 16px;
    letter-spacing: 23px;
    padding-left: 10px;
}

.password-dots-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 15px;
    background-color: #f5f7fa;
}

.password-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #dcdfe6;
    transition: all 0.3s;
}

.password-dot.filled {
    background-color: #303133;
}

.password-actions {
    text-align: right;
}

.password-actions .el-button {
    font-size: 14px;
    color: #409eff;
    padding: 0;
}

.dialog-footer {
    text-align: center;
    padding: 10px 20px 20px;
}

.dialog-footer .el-button {
    min-width: 100px;
}
</style>